'use client';
import Typography from '@/components/shared/typography/typography.component';
import Link from '@/components/WrappedLink';
import { ExchangeCarBannerIcon } from '../../../../../public/Images';
import myImageLoader from '@/image.local.loader';
import { useTranslation } from 'react-i18next';

const ExchangeCarBanner = ({ lang }: { lang: 'ar' | 'en' }) => {
    const { t } = useTranslation();

    return (
        <div
            className={
                'bnr-ex-bg container_exchange_banner bg-contain bg-gray-100 rounded-lg flex items-center justify-between p-6 flex-col md:flex-row md:justify-between'
            }
        >
            <div className={'iconContainer flex items-center'}>
                <div className={'carIconContainer w-24'}>
                    <img
                        className={'w-full object-contain'}
                        width={96}
                        height={84}
                        fetchPriority={'low'}
                        src={myImageLoader({
                            src: ExchangeCarBannerIcon.src,
                            width: 96,
                            height: 84,
                            quality: 75,
                            fillColor: 'transparent',
                        })}
                        alt={t('Exchange your Used Car Today')}
                    />
                </div>

                <div className={'textContainer ml-4 mr-4'}>
                    <Typography variant="h5Bold">
                        {t('Exchange your Used Car Today')}
                    </Typography>
                </div>
            </div>

            <div
                className={
                    'buttonContainer flex flex-1 justify-end w-full md:w-min mt-4'
                }
            >
                <Link
                    className={
                        'inline-flex items-center justify-center relative box-border cursor-pointer select-none align-middle appearance-none no-underline min-w-[200px] text-white shadow-[rgba(0,0,0,0.2)_0_3px_1px_-2px,rgba(0,0,0,0.14)_0px_2px_2px_0px,rgba(0,0,0,0.12)_0px_1px_5px_0px] bg-[rgb(0,45,93)] h-10 m-0 px-4 py-1.5 rounded-lg border-0  w-full md:w-min'
                    }
                    href={`/${lang}/sell-car`}
                >
                    <Typography color="white" variant="body2Medium">
                        {t('Sell Your Car')}
                    </Typography>
                </Link>
            </div>
        </div>
    );
};
export default ExchangeCarBanner;
